import getSelectedVideoStatus from './getSelectedVideoStatus';
import { urlSearch } from '@/search';

export default (props) => {
  const { location, isTopicsPage, params, isInSearchContext } = props;
  const { id, orgId, type } = params;
  const rootUrl = type === 'live' ? '/live_videos' : '/videos';
  let url = `${rootUrl}?organization_id=${orgId}&status=${getSelectedVideoStatus()}`;

  if (isInSearchContext) {
    const urlParams = urlSearch.getParams(location.search);
    urlParams.delete('status');
    const search = urlParams.toString();
    if (search) url += `&${search}`;
  } else if (isTopicsPage) {
    url += `&content_list_item_id=${id}`;
  }

  return { url };
};
